var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 7.09466C19.0667 7.09466 17.1747 7.64048 15.5476 8.59107C15.2671 5.71548 13.8976 2.89483 11.6481 0.647467L11 0L10.3519 0.647467C8.10242 2.89483 6.732 5.71639 6.45242 8.59107C4.82533 7.64048 2.93425 7.09466 0.916667 7.09466H0V8.01046C0 13.7617 4.44492 18.4945 10.0833 18.9615L11 19L11.9167 18.9615C17.5551 18.4945 22 13.7617 22 8.01046V7.09466H21.0833ZM11 2.63657C12.8563 4.77679 13.8261 7.30988 13.7656 9.88601C12.5895 10.9346 11.6398 12.2323 11 13.6939C10.3602 12.2314 9.4105 10.9346 8.23442 9.88601C8.17483 7.30988 9.14375 4.77679 11 2.63657ZM1.88375 8.97662C6.16733 9.42811 9.581 12.8385 10.0329 17.118C5.74933 16.6666 2.33567 13.2561 1.88375 8.97662ZM11.9671 17.118C12.419 12.8385 15.8327 9.42811 20.1163 8.97662C19.6643 13.2561 16.2507 16.6666 11.9671 17.118Z",
    fill: "#5C6C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenIcon3);
export default __webpack_public_path__ + "static/media/amen-icon-3.8e5c5ce18c43a5f31c6cb1c700ccbce0.svg";
export { ForwardRef as ReactComponent };